module.exports = __webpack_public_path__ + "static/media/Valerie Demers.3b41beac.png";